"use strict";
import { TradeType } from "@uniswap/sdk-core";
import useAutoSlippageTolerance from "hooks/useAutoSlippageTolerance";
import { useDebouncedTrade } from "hooks/useDebouncedTrade";
import { useMemo } from "react";
import { RouterPreference } from "state/routing/types";
import { isClassicTrade } from "state/routing/utils";
export default function useDerivedPayWithAnyTokenSwapInfo(inputCurrency, parsedOutputAmount) {
  const { state, trade } = useDebouncedTrade(
    TradeType.EXACT_OUTPUT,
    parsedOutputAmount,
    inputCurrency ?? void 0,
    RouterPreference.API
  );
  const allowedSlippage = useAutoSlippageTolerance(isClassicTrade(trade) ? trade : void 0);
  const maximumAmountIn = useMemo(() => {
    const maximumAmountIn2 = trade?.maximumAmountIn(allowedSlippage);
    return maximumAmountIn2?.currency.isToken ? maximumAmountIn2 : void 0;
  }, [allowedSlippage, trade]);
  return useMemo(() => {
    return {
      state,
      trade,
      maximumAmountIn,
      allowedSlippage
    };
  }, [allowedSlippage, maximumAmountIn, state, trade]);
}
